import { render, staticRenderFns } from "./FormBranch.vue?vue&type=template&id=d2cb1a3e&"
import script from "./FormBranch.vue?vue&type=script&lang=js&"
export * from "./FormBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports